import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { assetUrl } from '../data/assets';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  wrapperClassName?: string;
};

export function ImageWithFallback({ wrapperClassName = '', className = '', alt = '', ...props }: Props) {
  const [failed, setFailed] = useState(false);

  return (
    <div className={`image-fallback-shell ${wrapperClassName}`}>
      {!failed ? (
        <img
          {...props}
          src={typeof props.src === 'string' ? assetUrl(props.src) : props.src}
          alt={alt}
          className={className}
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="image-fallback" role="img" aria-label={`${alt} placeholder`}>
          <ImageOff size={28} aria-hidden="true" />
          <span>Add your photo</span>
        </div>
      )}
    </div>
  );
}
